import requestLoginCredentials from './requestLoginCredentials';
import authentication from './authentication';
import currentUser from './currentUser';
import metadata from './metadata';
import companyOnboarding from './companyOnboarding';
import company from './company';
import comments from './comments';
import student from './student';
import hitSearch from './hitSearch';
import appSettings from './appSettings';
import hitManager from './hitManager';
import chat from './chat';
import searchGeneral from './searchGeneral';
import notifications from './notifications';
import appTour from './appTour';
import buddies from './buddies';
import traits from './traits';
import hitClub from './hitClub';
import payments from './payments';
import {reducer as toastrReducer} from 'react-redux-toastr';

export default {

  requestLoginCredentials,
  authentication,
  currentUser,
  metadata,
  companyOnboarding,
  company,
  comments,
  toastr: toastrReducer,
  student,
  hitSearch,
  appSettings,
  hitManager,
  chat,
  searchGeneral,
  notifications,
  appTour,
  buddies,
  traits,
  hitClub,
  payments
  
};
